<template>
  <div>
    Contact page
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
